import { isServer } from '@/utils/tool';

/**
 * 根据ID判断元素是否在可视区
 * @param id element id
 * @param offset 偏移量,默认为0
 * @returns
 */
const elementInView = (id, offset = 0) => {
  if (isServer) return;
  const el = document?.getElementById(id);
  if (!id || !el) {
    return;
  }
  const box = el.getBoundingClientRect(),
    top = box.top >= 0,
    left = box.left >= 0,
    bottom = box.bottom <= (window.innerHeight || document.documentElement.clientHeight) + offset,
    right = box.right <= (window.innerWidth || document.documentElement.clientWidth) + offset;
  return top || left || bottom || right;
};

export default elementInView;
